var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "table-new-ux-group-by-v1",
        attrs: {
          headers: _vm.headers,
          items: _vm.tableRows,
          "group-by": _vm.groupBy,
          "custom-sort": _vm.customSort,
          "hide-default-footer": "",
          "disable-pagination": ""
        },
        scopedSlots: _vm._u([
          {
            key: "group.header",
            fn: function(ref) {
              var group = ref.group
              var groupItems = ref.items
              return _vm._l(_vm.headers, function(headerItem) {
                return _c(
                  "td",
                  {
                    key: headerItem.value || headerItem.text,
                    staticClass: "text-semibold"
                  },
                  [
                    headerItem.value === "nome_ativo"
                      ? _c("span", [_vm._v(" " + _vm._s(group) + " ")])
                      : headerItem.value === "pl_atual"
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.sumGroupMoney(groupItems, "pl_atual")
                              ) +
                              " "
                          )
                        ])
                      : headerItem.value === "pl_final"
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.sumGroupMoney(groupItems, "pl_final")
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              })
            }
          },
          {
            key: "item.movimentacao",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", { class: _vm.getMovementClass(item) }, [
                  _vm._v(" " + _vm._s(item.movimentacao) + " ")
                ])
              ]
            }
          },
          {
            key: "item.recomendacao",
            fn: function(ref) {
              var item = ref.item
              return [
                item.recomendacao
                  ? _c(
                      "v-chip",
                      {
                        attrs: {
                          "x-small": "",
                          color:
                            _vm.recomendacaoColors[item.recomendacao] || "grey",
                          dark: ""
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.recomendacaoLabels[item.recomendacao] ||
                                item.recomendacao
                            ) +
                            " "
                        )
                      ]
                    )
                  : _c("span", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.setor",
            fn: function(ref) {
              var item = ref.item
              return [
                item.setor
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "text-truncate",
                                          staticStyle: { "max-width": "120px" }
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(" " + _vm._s(item.setor) + " ")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [_c("span", [_vm._v(_vm._s(item.setor))])]
                    )
                  : _c("div", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.comentario",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("CommentDisplay", {
                  attrs: {
                    "comment-text": item && item.comentario,
                    "display-mode": "text"
                  }
                })
              ]
            }
          },
          {
            key: "item.tags",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm.getTags(item).length
                  ? _c("ClientTags", {
                      attrs: { tags: _vm.getTags(item), useSmallChips: "" }
                    })
                  : _c("div", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm.hasActionColumn
                  ? _c("TableRowActions", { attrs: { actions: item.actions } })
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }